import { type RewardPointsSnackbarProps } from '../models';

export const getRewardPointsSnackbarProps = (amount: number, behaviorId?: string) => {
	return {
		amount,
		behaviorId,
		testID: 'rewardPointsSnackbar'
	} satisfies RewardPointsSnackbarProps;
};
